import { ModulePicker } from "./ModulePicker";
import { LocationGuard } from "./LocationGuard";

export const Location = () => {
  return (
    <LocationGuard>
      <ModulePicker/>
    </LocationGuard>
  );
};
